import { ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { CopiedGrid } from '../../../../../orders/orderState.types';
import { useCatalogListContextParams } from '../../hooks/useCatalogListContextParams';

const EMPTY_COPIED_GRID: CopiedGrid = { grid: [], product: undefined, orderId: '' };

interface CatalogListCopiedGridValue {
  copiedGrid: CopiedGrid;
  copyGrid: (grid: CopiedGrid) => void;
  removeCopiedGrid: () => void;
}

const CatalogListCopiedGridContext = createContext<CatalogListCopiedGridValue>({
  copiedGrid: EMPTY_COPIED_GRID,
  copyGrid: () => undefined,
  removeCopiedGrid: () => undefined,
});

interface CatalogListCopiedGridProviderProps {
  children: ReactNode;
}

export const CatalogListCopiedGridProvider = ({ children }: CatalogListCopiedGridProviderProps) => {
  const { orderId } = useCatalogListContextParams();
  const [copiedGrid, setCopiedGrid] = useState<CopiedGrid>(EMPTY_COPIED_GRID);

  const removeCopiedGrid = () => setCopiedGrid(EMPTY_COPIED_GRID);

  useEffect(() => {
    setCopiedGrid(EMPTY_COPIED_GRID);
  }, [orderId]);

  return (
    <CatalogListCopiedGridContext.Provider
      value={{ copiedGrid, copyGrid: setCopiedGrid, removeCopiedGrid }}
    >
      {children}
    </CatalogListCopiedGridContext.Provider>
  );
};

export const useCatalogListCopiedGrid = () => useContext(CatalogListCopiedGridContext);
